interface TrackerEventLike {
  __typename?: string;
  activitySourceType?: string;
  caloriesBurned?: number;
}

/**
 * Whether the daily tracker must show the Garmin data-attribution note.
 *
 * Garmin requires attribution wherever data sourced from their API is shown.
 * The burned-calories total is the sum of `caloriesBurned` over the top-level
 * activities the backend returns in `events`; each activity's sourceType
 * reflects the source of the calories actually counted (for merged rows the
 * backend resolves it to the contributing biometric source). So the note is
 * shown only when those visible calories include a Garmin-sourced activity:
 * hidden when burned is 0, when the user has no Garmin data, or when today's
 * activities come from other sources only.
 */
export const includesGarminData = (trainingCalories: number, events: TrackerEventLike[]): boolean =>
  trainingCalories > 0 &&
  events.some(
    (event) =>
      event.__typename === 'SimpleDailyTrackerActivity' &&
      event.activitySourceType === 'openwearables_garmin' &&
      (event.caloriesBurned ?? 0) > 0
  );
